export default __webpack_public_path__ + "static/media/add_webLink.1b30d1a8.png";